import * as React from 'react';

export type CheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
    indeterminate?: boolean;
    children?: React.ReactNode;
};

export const Checkbox: React.FC<CheckboxProps> = ({ children, indeterminate = false, style, type, ...props }) => {
    const ref = React.useRef<HTMLInputElement>(null);

    React.useEffect(() => {
        if (ref.current) {
            ref.current.indeterminate = indeterminate;
        }
    });

    return (
        <div className="checkbox" style={style}>
            <label>
                <input ref={ref} {...props} type={type ?? 'checkbox'} />
                {children}
            </label>
        </div>
    );
};
Checkbox.displayName = 'Checkbox';
